
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutCTA() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section ref={ref} className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bb03a331dbcdfbacd10e87cde51f052f.jpg"
          alt="Let us work together"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-slate-900/70"></div>
      </div>

      <div
        className={`relative max-w-3xl mx-auto px-6 text-center transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <h2
          className="text-4xl lg:text-5xl font-bold text-white mb-5"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Ready to grow together?
        </h2>
        <p className="text-lg text-white/85 mb-10 leading-relaxed max-w-xl mx-auto">
          Whether you’re launching from scratch or levelling up an existing presence, we’d love to hear your story and show you what’s possible.
        </p>
        <Link
          /* Updated the target path to avoid parsing issues with a leading slash before a hash */
          to="/contact"
          className="inline-flex items-center gap-3 px-9 py-4 bg-[#00989e] text-white font-semibold rounded-full hover:bg-[#007a7f] transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
        >
          <span className="uppercase tracking-wide text-sm">Book a Free Strategy Call</span>
          <i className="ri-arrow-right-up-line text-xl"></i>
        </Link>
      </div>
    </section>
  );
}
